import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Footer from '../Footer';

const DashboardLayout = ({ children, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#070b14] text-gray-100">
      {/* Mobile Header */}
      <header className="bg-[#0a0f1e] border-b border-white/5 px-4 py-3 flex justify-between items-center md:hidden sticky top-0 z-20">
        <div className="flex items-center gap-2">
          <img src="/logo-icon.png" alt="SiteScope Logo" className="w-8 h-8" />
          <h1 className="text-xl font-bold text-white">SiteScope</h1>
        </div>
        <button 
          className="md:hidden p-2 hover:bg-white/5 rounded-lg transition-colors"
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          <span className="material-icons text-white">
            {sidebarOpen ? 'close' : 'menu'}
          </span>
        </button>
      </header>
      
      <div className="flex flex-1 relative">
        {/* Mobile Overlay */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
            onClick={toggleSidebar}
          />
        )}
        
        {/* Sidebar */}
        <div className={`
          fixed md:static inset-y-0 left-0 z-40 w-64 transform transition-transform duration-300 ease-in-out
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}>
          <Sidebar onLogout={onLogout} onClose={() => setSidebarOpen(false)} />
        </div>
        
        {/* Main Content */}
        <div className="flex-1 flex flex-col">
          <main className="flex-1 p-3 sm:p-4 md:p-6 lg:p-8 overflow-y-auto">
            {children}
          </main>
        </div>
      </div>

      {/* Footer - Full Width Below Everything */}
      <Footer variant="dashboard" />
    </div>
  );
};

export default DashboardLayout;
